import React from 'react';
import NavBar from 'Components/navbar';
import container from './style';
import { Drawer } from 'Components/Drawer/Drawer/Drawer';

export default function SideBarContainer({ children, navBar = true }) {
  return (
    <div className="flex">
      <Drawer />
      <div style={container} className="col">
        {navBar ? <NavBar /> : null}

        {children}
      </div>
    </div>
  );
}
